import { WebinarInfo } from "@/models/WebinarInfo"
import IFullVideoData, { FullVideoData } from "@/models/FullVideoData"
import mergeSubtitles from "@/services/mergeSubtitles"
export function getFullVideo(webinatInfo: WebinarInfo): IFullVideoData {
  if (webinatInfo.video_urls)
    return new FullVideoData(webinatInfo.video_urls, mergeSubtitles(webinatInfo.subtitle_urls, webinatInfo.subtitles))
  return new FullVideoData(undefined, undefined)
}
